const initialState = {
    logged: false,
    beacon: false,
    extensionStatus: 'missing',
    beaconApply: false,
    redirect: "",
    apiResponsed: false,
    bufferRefreshDevice: false
  };
  
  export const rLink = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_BUFFER_REFRESH_DEVICE': {
        return {
          ...state,
          bufferRefreshDevice: action.buffer
        };
      }
      case 'CLEAR_BUFFER_REFRESH_DEVICE': {
        return {
          ...state,
          bufferRefreshDevice: false
        };
      }
      case 'RLINK_SET_BEACON': {
        return {
          ...state,
          beacon: action.beacon,
          extensionStatus: action.extensionStatus,
          beaconApply: true
        };
      }
      case 'SET_INITED' : {
        return {
          ...state,
          logged: true
        };
      }
      case 'SET_LOGOUT' : {
        return {
          ...state,
          logged: false
        };
      }
      case 'RLINK_SET_API_RESPONSED' : {
        return {
          ...state,
          apiResponsed: true
        }
      }
      case 'RLINK_SET_REDIRECT' : {
        return {
          ...state,
          redirect: action.redirect
        };
      }
      default:
        return state;
    }
  };
